import { ActiveEventsOpenActionKey } from "../../../actions/ActionKeys";
import { ActiveEventsOpenAction } from "../../../actions/activeEventsOpen";

/** The active event open redux state. */
export const activeEventsOpen = (
  state: boolean = false,
  action: ActiveEventsOpenAction
): boolean => {
  switch (action.type) {
    case ActiveEventsOpenActionKey.SET_ACTIVE_EVENTS_OPEN:
      return action.payload.open;
    default:
      return state;
  }
};
